const STATUS_BADGES = {
    pending: 'bg-warning',
    link_sent: 'bg-info',
    activated: 'bg-success',
    rejected: 'bg-danger',
};

const STATUS_LABELS = {
    pending: 'Pending',
    link_sent: 'Link sent',
    activated: 'Activated',
    rejected: 'Rejected',
};

/**
 * props:
 * - data
 * - onApproveClick
 * - onRejectClick
 * - onCopyClick
 * - onActivateClick
 */
function UpgradeRequestRow(props) {
    const request = props.data;
    const status = request.status;

    return (
        <tr>
            <td>
                {request.user?.name}
                <br />
                <small>{request.email}</small>
            </td>
            <td>
                {request.plan?.name}
                {request.plan?.priceMonthly
                    ? ` ($${Number(request.plan.priceMonthly).toFixed(2)})`
                    : ''}
            </td>
            <td>{request.note || '-'}</td>
            <td>
                <span className={`badge ${STATUS_BADGES[status] || 'bg-gray'}`}>
                    {STATUS_LABELS[status] || status}
                </span>
            </td>
            <td>{new Date(request.createdAt).toLocaleString()}</td>
            <td>
                {status === 'pending' || status === 'link_sent' ? (
                    <button
                        id={'approve' + request.id}
                        type="button"
                        className="btn btn-primary btn-xs ms-2"
                        title="Build the payment link and email it to the user"
                        onClick={props.onApproveClick}
                    >
                        {status === 'pending' ? 'Approve' : 'Resend link'}
                    </button>
                ) : (
                    <></>
                )}
                {status === 'link_sent' ? (
                    <>
                        <button
                            id={'copy' + request.id}
                            type="button"
                            className="btn btn-secondary btn-xs ms-2"
                            title="Copy the payment link"
                            onClick={props.onCopyClick}
                        >
                            Copy link
                        </button>
                        <button
                            id={'activate' + request.id}
                            type="button"
                            className="btn btn-success btn-xs ms-2"
                            title="Payment confirmed in Stripe: move the user to this plan"
                            onClick={props.onActivateClick}
                        >
                            Activate
                        </button>
                    </>
                ) : (
                    <></>
                )}
                {status === 'pending' || status === 'link_sent' ? (
                    <button
                        id={'reject' + request.id}
                        type="button"
                        className="btn btn-danger btn-xs ms-2"
                        title="Reject this request"
                        onClick={props.onRejectClick}
                    >
                        Reject
                    </button>
                ) : (
                    <></>
                )}
            </td>
        </tr>
    );
}

export default UpgradeRequestRow;
